/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Shepherd from 'shepherd.js';

var site = require('../../site/_data/site');

/*------------------------------------*\
    FEEDBACK TOUR REVIEW
\*------------------------------------*/
class FeedbackTourReview {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        var shepherd = new Shepherd.Tour({
          defaultStepOptions: {
            classes: 'tour-review',
            scrollTo: {
              behavior: 'smooth',
              block: 'center'
            }
          },
          steps: [
            {
              title: 'Review your feedback',
              text: 'This page shows the feedback you have entered so far for your review. When satisfied with your response, complete your details to submit your feedback at the bottom of this page.',
              buttons: [
                {
                  action: function() {
                    return this.next();
                  },
                  text: 'Close'
                }
              ]
            }
          ],
          useModalOverlay: true
        });

        // If consultation closed don't show
        if(site.consultation.feedback_active == true) {
          shepherd.start();
        }
    }
}

export default FeedbackTourReview;